import { computed } from 'vue'
import { useNuxtApp } from '#app/nuxt'

const useExperiments = () => {
  const { $experiments } = useNuxtApp()
  const { isActive } = $experiments

  return {
    showOdoscopePlp: computed(() => isActive('experiment-plp', 'odoscope-plp')),
    // TODO: remove this after new PDP is online for a while and we have enough data
    showNewPdp: computed(() => true),
    showCheckoutPageNewLayout: computed(() => true),
    showPdpFoldableColors: computed(() => isActive('experiment-pdp-foldable-colors', 'new')),
    showNewGallery: computed(() => isActive('experiment-pdp-gallery', 'new')),
    showNewDesktopPlpQuickFilters: computed(() => true),
    loadLeapScript: computed(() => isActive('experiment-leap-script', 'new')),
    showGoldnerClub: computed(() => isActive('experiment-goldner-club', 'new')),
    showChooseOneSizeModal: computed(() => isActive('experiment-choose-one-size', 'new')),
  }
}

export default useExperiments
